const OpenMenuIcon = ({ darkTheme }: { darkTheme: boolean }) => (
  <svg
    color={darkTheme ? "white" : "#1a1a1a"}
    width="34px"
    height="34px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Reports"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="nav-mobile-#1-–-tab"
        transform="translate(-319.000000, -16.000000)"
        stroke="currentColor"
      >
        <g id="menu-mobile-open" transform="translate(319.000000, 16.000000)">
          <rect
            id="Rectangle"
            strokeWidth="2"
            x="1"
            y="1"
            width="38"
            height="38"
            rx="4"
          ></rect>
          <rect
            id="Rectangle"
            x="8.5"
            y="13.5"
            width="23"
            height="1"
            rx="0.5"
          ></rect>
          <rect
            id="Rectangle-Copy-4"
            x="8.5"
            y="19.5"
            width="23"
            height="1"
            rx="0.5"
          ></rect>
          <rect
            id="Rectangle-Copy-5"
            x="8.5"
            y="25.5"
            width="23"
            height="1"
            rx="0.5"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);

export default OpenMenuIcon;
